@if (isLegacyHideInCartLevel) {
  <pdq-banner
    class="legacy-hide-in-cart-banner"
    variant="attention"
    bannerTitle="Legacy cart detection in use"
    content="This offer hides the gift when it's already in the cart using legacy detection. Once saved, the selected detection level (parent product or specific variant) will replace it."
    button="Review detection level"
    [plainButton]="true"
    [closable]="false"
    (onButtonClick)="onReviewHideInCartLevel()">
  </pdq-banner>
}

<pdq-tabs-group class="gift-unlock-tabs" variant="underline" (onChange)="onTabChange($event)" [leftMargin]="'none'">
  @for (tab of tabs; track tab.value) {
    <pdq-tab
      [label]="tab.label"
      [value]="tab.value"
      [active]="tab.value === activeTab"
      [disabled]="tab.value === GiftUnlockTab.GIFT_MESSAGE && isGiftMessageTabDisabled">
    </pdq-tab>
  }
</pdq-tabs-group>

<div class="checkout-shipping-upsell">
  <div class="content">
    @if (formGroup) {
      <form [formGroup]="formGroup">
        @switch (activeTab) {
          @case (GiftUnlockTab.SETTINGS) {
            <gift-unlock-settings
              [formGroup]="formGroup"
              [displayRules]="displayRules"
              [displayRulesEntities]="displayRulesEntities"
              [shopCurrencySymbol]="shopCurrencySymbol"
              [offerTypeOptions]="offerTypeOptions">
            </gift-unlock-settings>
          }
          @case (GiftUnlockTab.GIFT_MESSAGE) {
            <gift-unlock-gift-message
              [formGroup]="formGroup"
              [displayDesignConfigurationSections]="displayDesignConfigurationSections"
              [activePreviewMode]="activePreviewMode"
              [defaultIconUrl]="defaultIconUrl"
              (previewToggle)="onTogglePreviewBetweenGiftBannerAndOffer()">
            </gift-unlock-gift-message>
          }
          @case (GiftUnlockTab.OFFER) {
            <gift-unlock-offer
              #giftUnlockOffer
              [formGroup]="formGroup"
              [offerTypeOptions]="offerTypeOptions"
              [couponTypeOptions]="couponTypeOptions"
              [shopCurrencySymbol]="shopCurrencySymbol"
              [popupActiveTab]="popupActiveTab"
              [giftMessageEnabled]="formGroup?.get('giftMessage.enabled')?.value"
              [updateRequired]="updateRequired"
              [updateAppUrl]="updateAppUrl"
              [activePreviewMode]="activePreviewMode"
              (popupTabChange)="onPopupTabChange($event)"
              (previewToggle)="onTogglePreviewBetweenGiftBannerAndOffer()">
            </gift-unlock-offer>
          }
        }
      </form>
    }
  </div>
</div>
